import React, { useState } from 'react';
import { Popover, PopoverProps } from 'react-tiny-popover';
import { ZIndex } from 'web-common/src/shared/styles';
import { ContentContainer, DefaultTriggerContainer, MenuIcon, MenuItem } from './styles';

export type ItemType = {
  isError?: boolean;
  label: React.ReactNode;
  onClick: () => void;
};

export interface TooltipProps {
  /** Additional style classes. */
  className?: string;
  /** Menu postions when menu opens. */
  positions?: PopoverProps['positions'];
  /** Overflow icon is vertical. */
  isVerticalIcon?: boolean;
  /** Items to display in menu. */
  items: ItemType[];
  /** Component to use as tooltip trigger. */
  triggerComponent?: string | React.ElementType;
}

export const OverflowMenu: React.FC<TooltipProps> = (props) => {
  const {
    className,
    items,
    isVerticalIcon = true,
    positions = ['bottom', 'top', 'left', 'right'],
    triggerComponent = DefaultTriggerContainer,
  } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const Trigger = triggerComponent;

  const menuItems = items.map((item, index) => (
    <MenuItem onClick={item.onClick} isError={item.isError} key={`${item.label}-${index}`}>
      {item.label}
    </MenuItem>
  ));

  return (
    <Popover
      reposition
      positions={positions}
      isOpen={isMenuOpen}
      onClickOutside={() => setIsMenuOpen(false)}
      containerStyle={{ zIndex: `${ZIndex.ModalContent}` }}
      content={() => <ContentContainer onClick={() => setIsMenuOpen(false)}>{menuItems}</ContentContainer>}>
      <Trigger className={className} isMenuOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <MenuIcon isVerticalIcon={isVerticalIcon} />
      </Trigger>
    </Popover>
  );
};
